import React, { useEffect, useState } from "react";
import { SmartFormInterFace, SmartSoftForm, SmartValid } from "soft_digi";
import { useSiteContext } from "../../contexts/SiteProvider";
import { get, post } from "../../services/smartApiService";
import { showNotification } from "../../services/notifyService";
import { USERS_URLS } from "../../api/UserUrls";
import { ROLES_URLS } from "../../api/RolesUrls";

interface childrenProps {
  dataIn?: any;
  existRoles?: any[];
  loadTableData: () => void
}

const initialValue = {
  role_name: "",
  users: ""
}

const CreateRole: React.FC<childrenProps> = ({dataIn, existRoles, loadTableData}) => {
  const [formData, setFormData] = useState(initialValue);
  const [allroles, setAllRoles] = useState<string[]>([])
  const [users, setUsers] = useState()
  const { setLoading, closeModal} = useSiteContext();
  
  useEffect(()=>{
    if(existRoles){
      setAllRoles(existRoles.map(item=>item.role_name));
    }
  },[]);

  useEffect(()=>{
    const subscription = get(USERS_URLS.GET_ALL_SELECT).subscribe((response) => {      
      setUsers(response.data.data);
    });
    return () => subscription.unsubscribe();
  },[])

  useEffect(()=>{
    if(dataIn){
      let updatedForm = {
        role_name: dataIn?.role_name,
        users: dataIn?.users,
      }
      setFormData(updatedForm)
    }
  },[])

  const formElements:SmartFormInterFace.SmartFormElementProps[] = [
    {
      type: "TEXT_BOX",
      width: "12",
      name: "role_name",
      element: {
        classList:["smart-form-input"],
        label: "Role Name",
        placeHolder: "Enter your Role Name",
        isRequired:true,
        inputProps:{ 
          disabledFunction:()=> dataIn && true
        }
      },
    },
    {
      type: "SELECT_BOX",
      width: "10",
      name: "users",
      element: {
        leftIcon:"fa-check",
        classList:["smart-form-input"],
        label: "Employees",
        placeHolder: "Select ", 
        isMulti: true, options: users,
      },
    },
    {
      type: "BUTTON",
      width: "12",
      name:"",
      class_name: "has-text-right",
      element: {
        label: "Save",
        classList: ["smart-action-button"],
        onClick: handleSave,
      },
    },
  ];

  const handleInputChange = (name: string, value: string) => {
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const getPayload= ()=>{
    const initialPayload ={
      roleName: formData?.role_name, 
      users: formData?.users,
    }
    if(dataIn) return {id: dataIn?.ID, ...initialPayload}
    return initialPayload
  }

  function handleSave() {
    if(formData?.role_name == "") {
      return showNotification("error","Please insert the Project Name")
    }
    if(allroles.includes(formData?.role_name.toUpperCase())) {
      return showNotification("error",`The "${formData?.role_name}" Role is Already exist, Please try another role`);
    }
    setLoading(true);
    const payload = getPayload();
    const api = dataIn ? ROLES_URLS.UPDATE : ROLES_URLS.INSERT
    const subscription = post(api,payload).subscribe((response) => {
      setLoading(false)
      setFormData(initialValue);
      showNotification("success",response.data.message)
      loadTableData();
      closeModal();
    });
    return () => subscription.unsubscribe();
  };

  return (
    <div className="sd-pdf-form">  
      <SmartSoftForm formData={formData}
        setFormData={handleInputChange}
        elements={formElements}
      />
    </div>
  );
}

export default CreateRole;
